import _ from "lodash";
import { Modal, SearchInput } from "@toddle-edu/ds-web";
import React, { useMemo, useState } from "react";
import { useI18n } from "Hooks";
import StandardSetsTable from "../StandardSetsTable";
import Loading from "UIComponents/Loading";
import HeaderDropdown from "../HeaderDropdown";
import classes from "./SelectSetModal.scss";

const TEST_ID_PREFIX = "planning-selectStandardSet";

const styles = {
  modalBodyStyle: {
    minHeight: 0,
  },
};

const SelectSetModal = props => {
  const {
    onClose,
    setStandardSetId,
    standardEdges,
    selectedStandards,
    selectedNodesSource,
    setSelectedNodesSource,
    showLoader,
    label,
  } = props;

  const [searchText, setSearchText] = useState("");

  const { t } = useI18n();

  const value = useMemo(() => {
    return _.toArray(selectedStandards || []);
  }, [selectedStandards]);

  return (
    <Modal isOpen onClose={onClose}>
      <Modal.Header
        testId={TEST_ID_PREFIX}
        title={label}
        actionElement={
          <div className={classes.headerActionElement}>
            <HeaderDropdown
              selectedNodesSource={selectedNodesSource}
              onChange={setSelectedNodesSource}
            />
            <div className={classes.searchContainer}>
              <SearchInput
                focusSearchBySlash
                value={searchText}
                onChange={setSearchText}
                testId={TEST_ID_PREFIX}
                placeholder={t("common:search_for_label", {
                  label: t("common:label_lowercase", {
                    label: t("scopeAndSequence:standard_set"),
                  }),
                })}
              />
            </div>
          </div>
        }
      />
      <Modal.Body style={styles.modalBodyStyle}>
        {showLoader ? (
          <Loading />
        ) : (
          <StandardSetsTable
            setStandardSetId={setStandardSetId}
            standardEdges={standardEdges}
            value={value}
            searchText={searchText}
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default SelectSetModal;
